// Replace {{supplier_name}}, {{product_name}}, {{quantity}}, {{budget}},
// {{moq}}, {{lead_time}}, {{risk_level}} with values from the supplier + request context.
// Unknown placeholders are left as-is so the user can fill them manually.

export const PLACEHOLDER_KEYS = [
  'supplier_name',
  'product_name',
  'quantity',
  'budget',
  'moq',
  'lead_time',
  'risk_level',
];

export function applyTemplate(body, ctx = {}) {
  if (!body) return '';
  const map = {
    supplier_name: ctx.supplier_name ?? '',
    product_name: ctx.product_name ?? '',
    quantity: ctx.quantity != null ? String(ctx.quantity) : '',
    budget: ctx.budget != null ? String(ctx.budget) : '',
    moq: ctx.moq != null ? String(ctx.moq) : '',
    lead_time: ctx.lead_time_days != null ? `${ctx.lead_time_days} days` : '',
    risk_level: ctx.risk_level ?? '',
  };
  return body.replace(/\{\{\s*([a-z_]+)\s*\}\}/gi, (match, key) => {
    const lower = key.toLowerCase();
    if (lower in map && map[lower] !== '') return map[lower];
    return match; // leave unresolved placeholder as-is
  });
}

export const TEMPLATE_CATEGORIES = [
  'price_inquiry',
  'moq_negotiation',
  'shipping_inquiry',
  'sample_request',
  'branding',
  'general_intro',
];
